function mapGetOnePremierAccessGroupsImportData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListPremierAccessGroupsImportsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOnePremierAccessGroupsImportData, mapGetListPremierAccessGroupsImportsData };
